import { render, staticRenderFns } from "./AddRemindereDialog.vue?vue&type=template&id=610b0e60&"
import script from "./AddRemindereDialog.vue?vue&type=script&lang=js&"
export * from "./AddRemindereDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports